export default "/_next/static/chunks/fonts/GraphikSemiboldItalic-2f206f04e4bd14c87ad157cfe55d2d16.otf";